import { Button, Flex, Image, Input, Text } from '@chakra-ui/react';
import { ChangeEvent } from 'react';
import { FormattedMessage } from 'react-intl';
import PlusIcon from '../../assets/icons/plusIcon.svg';
import { getPresignedAvatarUploadData, uploadPresignedAvatar } from '../../service/social';

interface UploadImageComponentProps {
    id: string;
    className: string;
    onChange(uploadImgURL: string): void;
    headerText?: string[];
    footerText?: string[];
    imageURL?: string;
}

export const UploadImageComponent = (props: UploadImageComponentProps) => {
    const handleInputChange = (e: ChangeEvent<HTMLInputElement>) => {
        const file = e?.target?.files?.[0];
        if (!!file) {
            URL.revokeObjectURL(props.imageURL || '');
            const imgURL = URL.createObjectURL(file);
            props.onChange(imgURL);
        }
    };

    const handleClearUpload = () => {
        props.onChange('');
        URL.revokeObjectURL(props?.imageURL || '');
    };

    const renderCustom = () => (
        <Flex className={'upload-image-content-container-custom'}>
            {!!props.headerText && (
                <Flex className={'upload-image-header'}>
                    {props.headerText?.map((text, idx) => (
                        <Text key={`${props.className}-custom-header-item-${idx}`}>{text}</Text>
                    ))}
                </Flex>
            )}

            <Flex className="upload-image-custom-image-container">
                <Image className={'upload-image-custom-image'} src={props?.imageURL} />
            </Flex>

            {!!props.footerText && (
                <Flex className={'upload-image-footer'}>
                    {props.footerText?.map((text, idx) => (
                        <Text key={`${props.className}-custom-footer-item-${idx}`}>{text}</Text>
                    ))}
                </Flex>
            )}

            <Flex className={'upload-image-controls'}>
                <label htmlFor={props.id}>
                    <Button className="upload-image-controls-update" pointerEvents={'none'}>
                        <FormattedMessage
                            id="upload-image.default-button-text"
                            defaultMessage="Update Image"
                        />
                    </Button>
                </label>
                <Button className="upload-image-controls-clear" onClick={handleClearUpload}>
                    <FormattedMessage id="global.clear" defaultMessage="Clear" />
                </Button>
            </Flex>
        </Flex>
    );

    const renderDefault = () => (
        <Flex className={'upload-image-content-container-default'}>
            {!!props.headerText && (
                <Flex className={'upload-image-header'}>
                    {props.headerText?.map((text, idx) => (
                        <Text key={`${props.className}-default-header-item-${idx}`}>{text}</Text>
                    ))}
                </Flex>
            )}

            <label className="upload-image-default-image-container" htmlFor={props.id}>
                <Image className={'upload-image-default-image'} src={PlusIcon} />
            </label>

            {!!props.footerText && (
                <Flex className={'upload-image-footer'}>
                    {props.footerText?.map((text, idx) => (
                        <Text key={`${props.className}-default-footer-item-${idx}`}>{text}</Text>
                    ))}
                </Flex>
            )}
        </Flex>
    );

    return (
        <Flex className={props.className}>
            <Input
                onChange={(e) => handleInputChange(e)}
                type={'file'}
                bgImage={props.imageURL}
                display={'none'}
                id={props.id}
            />

            {!!props?.imageURL ? renderCustom() : renderDefault()}
        </Flex>
    );
};
